import * as React from 'react';
import styled from 'styled-components';
import DraftColumnPlayerIcon from './DraftColumnPlayerIcon';
import { SortableElement } from 'react-sortable-hoc';
import IconX from './IconX';
class DraftColumnPlayer extends React.Component {
    constructor() {
        super(...arguments);
        this.hover = () => {
            if (!this.props.isSorting) {
                this.props.handlers.selectPlayer(this.props.player);
            }
        };
    }
    render() {
        console.log("render [DraftColumnPlayer]");
        let removeButton = null;
        if (this.props.isRemovingPlayers) {
            removeButton = React.createElement(IconX, { className: "button", width: "20px", height: "20px", clicked: () => { this.props.handlers.removePlayer(this.props.player, this.props.playerColumnPosition); } });
        }
        return (React.createElement(Container, { onMouseEnter: () => { this.hover(); } },
            removeButton,
            React.createElement(DraftColumnPlayerIcon, { player: this.props.player }),
            React.createElement("span", null, this.props.player.fullName)));
    }
}
;
export default SortableElement(DraftColumnPlayer);
const Container = styled.li `
  background-color: rgba(200,200,200,0.1);
  color: #fff;
  cursor: pointer;
  position: relative;
  vertical-align: middle;
  list-style: none none outside;
  user-select: none;

  span {
    padding-left: 10px;
  }

  &:nth-child(even) {
    background-color: rgba(150, 150, 150, 0.4);
  }
  
  .button {
    background-color: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(0, 0, 0, 0);
    height: 20px;
    padding: 9px 0;
    width: 40px;
  }

  .button:hover {
    background-color: rgba(0, 0, 0, 1);
    border: 1px solid rgba(255, 0, 0, 0.5);
  }
`;
//# sourceMappingURL=DraftColumnPlayer.js.map


// WEBPACK FOOTER //
// ./src/components/DraftColumnPlayer.js